import { NextErrorsPanel } from 'components/shared/ErrorsPanel/NextErrorsPanel';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import type { RejectedStatusProps } from './RejectedStatus.connect';
import { connectRejectedStatus } from './RejectedStatus.connect';

const Component: FC<RejectedStatusProps> = ({ errors, shouldDisplayErrorDetails }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="w-100 alert alert-discreet-danger d-flex mb-0 px-0">
      <div className="card-body">
        <NextErrorsPanel
          defaultErrorMessage={formatMessage({ id: 'unknownErrorContactSale' })}
          workflowErrors={errors ?? []}
          layout={shouldDisplayErrorDetails ? 'summaryAndDetails' : 'summaryOnly'}
          shouldUseRejectionCode={false}
        />
      </div>
    </div>
  );
};

Component.displayName = 'RejectedStatus';

export const RejectedStatus = connectRejectedStatus(Component);
